import React from 'react';
import { Box, TextField, Typography } from '@mui/material';
import { FormField } from '../../types';

interface TextFieldInputProps {
  field: FormField;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const TextFieldInput: React.FC<TextFieldInputProps> = ({ field, onChange }) => {
  const inputName = field.id === 'firstName' || field.id === 'lastName' ? field.id : field.name;

  return (
    <Box sx={{ mb: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 1 }}>
        <Typography
          component="label"
          htmlFor={inputName}
          sx={{ fontWeight: 500, color: '#000000' }}
        >
          {field.label || field.name}
        </Typography>
        {field.required && (
          <Typography sx={{ color: '#dc5456', fontWeight: 'bold' }}>*</Typography>
        )}
      </Box>
      <TextField
        fullWidth
        size="small"
        id={inputName}
        name={inputName}
        type={field.type}
        required={field.required}
        onChange={onChange}
        variant="outlined"
      />
    </Box>
  );
};

export default TextFieldInput;
